<template>
    <div>
        <div class="warpper-top" v-if="isLoadProfile && isLoadLocale">
            <div class="topbar-home">
                <div class="wrapper-level" v-show="levelName != 'NOTIER'" ><div class="level font-bold-en">{{levelName}}</div></div>
                <div class="wrapper-history" @click="cilckHistory()"><img class="icon-history" src="../assets/home/history.png" /> {{lbl.home.history}}</div>
            </div>
            <!-- <CampaignCard :campaignId="campaignCardId"  v-if="campaignCardId && !dashboardCardconfig && isLoadProfile && isLoadLocale"></CampaignCard> -->
            <DashboardCard :apiConfig="dashboardCardconfig" v-if="dashboardCardconfig && isLoadProfile && isLoadLocale && !campaignCardId"></DashboardCard>
        </div>
        <campaign-with-filter v-if="isLoadProfile && isLoadLocale" ></campaign-with-filter>
        <modal
            view="home"
            :busModal="busModal"
            @modalAlertHidden="onHideModalAlert($event)"
        ></modal>
        <keep-alive :max="1">
            <router-view class="new-router" :key="$route.fullPath" ></router-view>
        </keep-alive>
    </div>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Vue from "vue";

//Helper
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import DateTime from "@/helper/DatetimeHelper.js";


import Modal from "@/components/modal/Modal.vue";
import CampaignWithFilter from "@/components/CampaignWithFilter.vue";
// import CampaignCard from "@/components/CampaignCard.vue";
import DashboardCard from "@/components/DashboardCard.vue"

import BzbsUtil from "@/service/BzbsUtil.js";
import ThlPDPA from "@/service/ThlPDPA.js";

export default {
    name: "home",
    components: {
        Modal,
        CampaignWithFilter,
        // CampaignCard,
        DashboardCard
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isLoadProfile: false,
            isLoadLocale: false,
            isLogin: false,
            profile: {},
            user: {},
            level: null,
            levelName: null,
            campaignId: null,
            campaignCardId: "",
            dashboardConfig: Vue.bzbsConfig.mainConfig.DashboardConfig,
            HeaderConfig: Vue.bzbsConfig.mainConfig.CampaignHeaderConfig,
            busModal: new Vue(),
            dashboardCardconfig: "",
        };
    },
    created: function() {
        //this.showLoading();
        this.setName();
        Account.loginStatus().then(status => {
            this.isLogin = status;
            if (status) {
                this.user = Account.getCacheUser();
                // Account.apiUpdateProfileLocale(this.user.locale)
                // .then(profile => {
                //     if (profile) this.profile = profile;

                Locale.setLocale(this.user.locale);
                this.lbl = Locale.getLbl();
                this.isLoadLocale = true;
                this.level = this.user.detail.level;
                this.getConfigHeader();
                this.targetPage = Account.getCacheCustom('BzbsTarget');
                if (this.targetPage) {
                    var targetPath = "/" + this.targetPage;
                    this.$router.push(targetPath);
                }
                this.campaignId = this.user.detail.campaignID;
                this.campaignName = this.user.detail.name;
                this.profile = Account.getCacheProfile();
                this.CachecampaignID = Account.getCacheCustom('campaignId');
                if (!this.CachecampaignID) {
                    if (this.campaignId) {
                        Account.setCacheCustom('campaignId',this.campaignId);
                        var isPopup = Account.isPopup();
                        var path = "";
                        if (isPopup == "true") {
                            path = "/campaign/" + this.campaignId + "?popup=true";
                        } else {
                            path = "/campaign/" + this.campaignId;
                        }
                        this.$router.push(path);
                    }
                }
                this.enquiryConsent(() => {
                    this.isLoadProfile = true;
                    this.trackScreen();
                });
                //this.isLoadProfile = true;
                setTimeout(() => {
                    this.hideLoading();
                },1000)

                // })
                // .catch(() => {});
            }
        });

        // Vue.ga.screenName(this, "Home");
    },
    mounted: function() {
        this.showLoading();
    },
    methods: {
        trackScreen: function () {
            var gtm = Account.getTrackViewGTM(this.user);
            Vue.ga.screenName(this, "Home", gtm);
        },
        setName: function() {},
        switchLang: function(locale) {
            Account.apiUpdateProfileLocale(locale)
                .then(profile => {
                    if (profile) this.profile = profile;

                    Locale.setLocale(locale);
                    this.lbl = Locale.getLbl();
                    this.isLoadLocale = true;
                })
                .catch(() => {});
        },
        login: function() {
            Account.apiBzbsLogin(
                this.modelLogin.username,
                this.modelLogin.password
            )
            .then(objResult => {
                this.isLogin = true;
                this.profile = objResult.profile;
            })
            .catch(error => {
                console.log(error);
            });
        },

        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },

        getConfigHeader: function() {
            BzbsUtil.apiGetConfig(this.HeaderConfig)
                .then(result => {
                    this.setupCampaignHeader(result);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        setupCampaignHeader: function(objCampaignHeader) {
            this.campaignId = "";
            if (objCampaignHeader && objCampaignHeader.length > 0) {
                for (var i = 0; i < objCampaignHeader.length; i++) {
                    if (this.level == objCampaignHeader[i].level) {
                        this.dashboardCardconfig = objCampaignHeader[i].config;
                        this.campaignCardId = objCampaignHeader[i].id;
                        this.levelName = objCampaignHeader[i].levelname;
                    }
                }
            }
        },
        enquiryConsent: function(callback) {
            var bzbsToken = Account.getToken();
            ThlPDPA.apiGetConsentGA(bzbsToken)
            .then(result => {
                if (result.data && result.data.gaStatus) {
                    Account.setCacheCustom('consent',result.data.gaStatus);
                } else {
                    Account.setCacheCustom('consent',false);
                }

                if (callback)
                    callback();
            })
            .catch(error => {
                console.log(error);
                Account.setCacheCustom('consent',false);
                if (callback)
                    callback();
            });
        },

        // modal example
        openAlertModal: function(msg) {
            var configModal = {
                title: "Alert",
                message: msg,
                strBtnOk: "OK",
                tag: "home_alert"
            };
            this.busModal.$emit("showAlertModal", configModal);
        },
        openConfirmModal: function() {
            var configModal = {
                title: "Confirm",
                message: "Yes or No",
                strBtnOk: "Yes",
                strBtnCancel: "No",
                tag: "home_confirm"
            };
            this.busModal.$emit("showConfirmModal", configModal);
        },
        showLoading: function() {
            this.busModal.$emit("showLoadingModal");
        },

        hideLoading: function() {
            this.busModal.$emit("hideLoadingModal");
        },

        onHideModalAlert: function(event) {
            if (event.tag == "home_alert") {
                //console.log("modal alert hidden");
            }
        },
        cilckHistory: function() {
            //this.showLoading();
            var label = "view_redeem_history";
            var gtm = {
                 "event_label": label,
                 "timestamp": DateTime.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "click_buttons", label, null, gtm);
            // this.$router.push('/history');
            this.$router.push({ name: 'history'});
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.warpper-top {
    // background-color: $primery-color;
    background-image: url('../assets/home/bg-home-new.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-top: 53px;

    .topbar-home {
        width: 100%;
        display: inline-block;

        position: fixed;
        top: 0;
        background-image: url('../assets/home/bg-home-new.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        z-index: 2;

        .wrapper-level {
            float: left;
            padding: 15px 15px 7px 15px;

            .level {
                background-color: white;
                color: $primery-color;
                font-size: 18px;
                font-weight: bold;
                line-height: 1.3em;
                padding: 1px 10px 0;
                border: 1px solid;
                border-radius: 30px;
                @extend %content-shadow;
            }
        }
        .wrapper-history {
            float: right;
            padding: 15px 15px 5px 15px;
            color: white;
            font-size: 20px;


            .icon-history {
                width: 21px;
            }
        }
    }
}

</style>
<style lang="scss">
.keep-home {
    overflow: hidden;
}
.new-router {
    position: absolute;
    .layout {
        display: block;
        position: fixed;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
</style>

